@use '../../../common/styles/variables.scss';

.dot-menu {
  .MuiMenu-list {
    padding: 6px;
  }

  li:first-of-type {
    color: variables.$text-light-color;
    opacity: 1;
    font-size: 0.625rem;
    height: 1rem;
    margin-bottom: 2px;
  }
}
